import { DeviceDetectorService } from 'ngx-device-detector';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/guard/auth.service';
import { User } from 'src/models/user';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {
  userModel: User = new User();

  constructor(
    translate: TranslateService,
    protected authService: AuthService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
  }

  ngOnInit(): void {
  }

  logIn() {
    this.authService.login(this.userModel);
  }

  logOut() {
    this.authService.logout();
  }

}
